module.exports = __webpack_public_path__ + "static/media/Circle_of_Influence_Concern.06711196.png";